class ReviewsCarouselDots extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('ul');
    this.dots = Array.from(this.querySelectorAll('.reviews-carousel__dot'));
    this.items = Array.from(this.querySelectorAll('.reviews-carousel__item'));

    if (!this.list || this.dots.length === 0 || this.items.length === 0) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        const item = this.items[index];
        if (!item) return;
        this.list.scrollTo({
          left: item.offsetLeft - this.list.offsetLeft,
          behavior: 'smooth',
        });
      });
    });

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: this.list,
      threshold: 0.6,
    });

    this.items.forEach((item) => this.observer.observe(item));
  }

  onIntersect(entries) {
    const visible = entries.find((entry) => entry.isIntersecting);
    if (!visible) return;

    const activeIndex = visible.target.dataset.index;

    this.dots.forEach((dot) => {
      const isActive = dot.dataset.index === activeIndex;
      dot.classList.toggle('reviews-carousel__dot--active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }
}

customElements.define('reviews-carousel-dots', ReviewsCarouselDots);
